import { styled } from '@mui/system'
import { Checkbox, checkboxClasses, CheckboxProps } from '@mui/material'
import { gecinaBlueMain, gecinaBrownMain, WHITE } from '../../theme'
import { ChampDansFormulaire } from '../fields/types/typePourChampDansFormulaireModel'
import CheckIcon from '@mui/icons-material/Check'

const CustomCheckbox = styled((props: CheckboxProps & Partial<ChampDansFormulaire>) => (
	<Checkbox
		{...props}
		checkedIcon={<StyledCheckIcon />}
		icon={<StyledBoxIcon />}
	/>
))(() => ({
	[`&.${checkboxClasses.root}`]: {
		padding: 0
	},
	'& span[font-size="small"]': {
		width: '12px',
		height: '12px',
		border: `1px solid ${gecinaBlueMain}`
	},
	'& span[font-size="medium"]': {
		width: '26px',
		height: '26px',
		border: `2px solid ${gecinaBlueMain}`
	},
	'& .MuiSvgIcon-fontSizeSmall': {
		width: '16px',
		height: '16px'
	},
	'& .MuiSvgIcon-fontSizeMedium': {
		width: '30px',
		height: '30px'
	}
}))

const StyledCheckIcon = styled(CheckIcon)({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: '4px',
	color: WHITE,
	background: gecinaBrownMain
})

const StyledBoxIcon = styled('span')({
	display: 'flex',
	position: 'relative',
	padding: '0px',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '4px',
	background: 'transparent'
})

export default CustomCheckbox